import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useIntl, FormattedMessage } from "react-intl";
import { Space, Row, Spinner } from "@masterteam/mt-design-react";
import { Switch, Route, Redirect, withRouter, Link } from "react-router-dom";

import InitiativeKPIs from "../../InitiativeKPIs";
import ErrorBoundary from "../../ErrorBoundary";
import InitiativeRisks from "../../InitiativeRisks";
import InitiativeOverview from "../../InitiativeOverview";
import InitiativeProjects from "../../InitiativeProjects";
import InitiativeStakeholders from "../../InitiativeStakeholders";

import { ReactComponent as KPIsIcon } from "../../../assets/images/new-kpi.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/info-icon.svg";
import { ReactComponent as RisksIcon } from "../../../assets/images/risks-icon.svg";
import { ReactComponent as ProjectsIcon } from "../../../assets/images/projects-icon.svg";
import { ReactComponent as StakeholdersIcon } from "../../../assets/images/stakeholders-icon.svg";

import "./style.scss";

const Tabs = ({ loader, data, location }) => {
  const intl = useIntl();
  const params = useParams();
  const isAr = intl.locale === "ar";
  const [index, setIndex] = useState(0);

  const routes = [
    {
      name: "initiative.overview",
      path: `/splus/initiative-details/${params?.id}/overview`,
      component: () => <InitiativeOverview data={data} />,
      icon: <InfoIcon className="tab-icon" />,
      showInNav: true,
    },
    {
      name: "initiative.initiatives-performance-indicators",
      path: `/splus/initiative-details/${params?.id}/kpis`,
      component: () => <InitiativeKPIs data={data} />,
      icon: <KPIsIcon className="tab-icon" />,
      showInNav: true,
    },
    {
      name: "initiative.stakeholders",
      path: `/splus/initiative-details/${params?.id}/stakeholders`,
      component: () => <InitiativeStakeholders data={data} />,
      icon: <StakeholdersIcon className="tab-icon" />,
      showInNav: true,
    },
    {
      name: "initiative.programs-and-projects",
      path: `/splus/initiative-details/${params?.id}/projects`,
      component: () => <InitiativeProjects data={data} />,
      icon: <ProjectsIcon className="tab-icon" />,
      showInNav: true,
    },
    {
      name: "common.risks",
      path: `/splus/initiative-details/${params?.id}/risks`,
      component: () => <InitiativeRisks data={data} />,
      icon: <RisksIcon className="tab-icon" />,
      showInNav: true,
    },
  ];

  useEffect(() => {
    const { pathname } = location;
    setIndex(
      routes.findIndex((item) => {
        return item.path === pathname;
      })
    );
  }, [location]);

  return (
    <Space className="initiative-taps">
      <ErrorBoundary>
        {loader ? (
          <Row justify="center" align="center" style={{ height: "100%" }}>
            <Spinner size="large" />
          </Row>
        ) : (
          <Space className="tabs-container" direction="vertical">
            <div className="header-wrapper d-flex">
              {routes.map((item, i) => (
                <Link to={item?.path} key={i}>
                  <Space
                    align="center"
                    onClick={() => setIndex(i)}
                    className={`menu-item ${index === i && "active"}`}
                  >
                    <div className="menu-item_icon">{item?.icon}</div>
                    {item.name ? (
                      <FormattedMessage
                        id={item.name}
                        defaultMessage={item.name}
                      />
                    ) : isAr ? (
                      item.arabicName
                    ) : (
                      item.englishName
                    )}
                  </Space>
                </Link>
              ))}
            </div>

            <div className="content-container">
              <Switch>
                {routes.map(({ path, name, component }) => (
                  <Route
                    path={path}
                    name={name}
                    component={component}
                    key={name}
                  />
                ))}

                <Redirect
                  from="/"
                  to={`/splus/initiative-details/${params?.id}/overview`}
                />
              </Switch>
            </div>
          </Space>
        )}
      </ErrorBoundary>
    </Space>
  );
};

export default withRouter(Tabs);
